import Heading from '@eversports/klimt-primitives/legacy/Heading'
import Stack from '@eversports/klimt-primitives/legacy/Stack'

import type { Meta } from '../../../App.types'
import MetaHelmet from '../../../components/MetaHelmet'
import { Localized, useIntl } from '../../../localization/react'
import SectionWrapper from '../components/SectionWrapper'
import type { Venue } from '../VenueProfile.types'

import { VenueVouchersBanner } from './Vouchers/VenueVouchersBanner'

interface Props {
  venue: Venue
  meta: Meta
}

export function VenueVouchers({ venue, meta }: Props) {
  const intl = useIntl()
  const metaTitle = `${intl.venueTabVoucher()} - ${meta.title}`

  return (
    <>
      <MetaHelmet noIndex meta={{ ...meta, title: metaTitle }} />
      <Stack gap={4} sx={{ width: '100%' }}>
        <SectionWrapper sx={{ gap: 5, background: 'transparent', border: 0, boxShadow: 0 }}>
          <Heading is="h1">
            <Localized id="venue-vouchers-page-title" params={{ venueName: venue.name }} />
          </Heading>
          <VenueVouchersBanner
            name={venue.name}
            voucherWidgetUrl={venue.voucherWidgetUrl}
            hasMultipleBranches={venue.company.venues.some((companyVenue) => companyVenue.id !== venue.id)}
          />
        </SectionWrapper>
      </Stack>
    </>
  )
}
